exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.load_form_btn[data-v-1e02e620] {\r\n  margin-right: 50px;\r\n  display:block;\r\n  float:right;\r\n  cursor:pointer;\r\n  border:1px solid #DCDFE6;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e02e620","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketTaskFormDialog.vue
// module id = 809
// module chunks = 75